import { useQuery } from '@tanstack/react-query';

import { IErrorNotif } from '../types';
import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

type ImperativeRequestFn = ReturnType<typeof useImperativeRequestWrapper>[1];

const getErrorNotifs = async ({
  partnerId,
  makeRequest,
}: {
  partnerId: string;
  makeRequest: ImperativeRequestFn;
}): Promise<IErrorNotif[]> => {
  const { data, error } = await makeRequest({
    path: `/partners/${partnerId}/webhooks/error-notifs`,
    method: 'get',
  });
  if (error) throw new Error(error?.message ?? String(error));

  return data?.notifs ?? [];
};

type QueryFnType = typeof getErrorNotifs;

export const useGetErrorNotifs = (
  partnerId: string,
  config?: QueryConfig<QueryFnType>
) => {
  const [, makeRequest] = useImperativeRequestWrapper('lpVillageV3');

  return useQuery<ExtractFnReturnType<QueryFnType>>({
    enabled: !!partnerId,
    staleTime: 5 * 60 * 1000,
    ...config,
    queryKey: ['webhook-error-notifs', partnerId],
    queryFn: () => getErrorNotifs({ partnerId, makeRequest }),
  });
};
